import "core-js/modules/es.number.constructor.js";
import { SButton } from '@strana-artw/ui-kit';
import CBean from '@/shared/ui/CBean.vue';
export default {
  name: 'StatusBanner',
  components: {
    SButton: SButton,
    CBean: CBean
  },
  props: {
    button: {
      type: Object,
      default: null
    },
    title: {
      type: [String, Number],
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  }
};